import {
  faFacebook,
  faInstagram,
  faLinkedinIn,
  faSpotify,
  faTiktok,
  faWhatsapp,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import NextLink from "next/link";
import { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import * as config from "../../../config/config";
import { setEmployerParams } from "../../../helpers/multicountry_management";
import packageJson from "../../../package.json";
import { LinkTextNoMargin } from "../SharedCollapsibleFooter/styles";
import {
  ColumnContainer,
  ColumnContainerMiddle,
  ColumnLink,
  CompanyTitleStyled,
  ContainerStyled,
  ContentContainer,
  CopyrightContainer,
  CopyrightContainerMiddle,
  CopyrightText,
  DownloadAppLogo,
  FirstContentContainer,
  GetInTouchTitleStyled,
  GridIcons,
  GridIconsContainer,
  GridLinks,
  GridLinksContainer,
  GridMission,
  IconStyled,
  LinkContactExternal,
  LinkExternal,
  LinkIcon,
  LinkStyled,
  LinkText,
  MissionText,
  PhoneIconStyled,
  QrCode,
  VanillaLinkStyled,
  VerticalSeparator,
  WhatsappIconStyled,
} from "./styles";

export default function SharedFooter() {
  let year = new Date().getFullYear();
  const [hasMounted, setHasMounted] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    setHasMounted(true);
  }, []);

  return (
    <Fragment>
      {hasMounted == true ? (
        <ContainerStyled>
          <ContentContainer>
            <FirstContentContainer>
              <ColumnContainer section="mission">
                <GridLinksContainer>
                  <CompanyTitleStyled>hiredly</CompanyTitleStyled>
                  <div>
                    <GridMission>
                      <MissionText>
                        {/* Our vision is to be SEA's most personalised talent
                        ecosystem; elevating human progress by helping careers
                        and companies grow.  */}
                        {t("footer.mission_paragraph_1")}
                      </MissionText>
                      <MissionText>
                        <br></br>
                        {t("footer.mission_paragraph_2")}
                      </MissionText>
                    </GridMission>
                  </div>
                </GridLinksContainer>
              </ColumnContainer>

              <ColumnContainerMiddle>
                <ColumnLink>
                  <CompanyTitleStyled>hiredly</CompanyTitleStyled>
                  <GridLinks>
                    <VanillaLinkStyled href="/about-us">
                      <LinkText id={"footer-about-us-button"}>
                        {t("footer.about_us")}
                      </LinkText>
                    </VanillaLinkStyled>
                    <VanillaLinkStyled href="/contact-us">
                      <LinkText id={"footer-contact-us-button"}>
                        {t("footer.contact_us")}
                      </LinkText>
                    </VanillaLinkStyled>
                    <VanillaLinkStyled href="/newsroom">
                      <LinkText id={"footer-newsroom-button"}>
                        {t("footer.newsroom")}
                      </LinkText>
                    </VanillaLinkStyled>
                    <VanillaLinkStyled href="/faq">
                      <LinkText id={"footer-faq-button"}>
                        {t("footer.faq")}
                      </LinkText>
                    </VanillaLinkStyled>
                    <VanillaLinkStyled href="/companies/hiredly-x">
                      <LinkText id={"hiredly-x-button"}>
                        {t("footer.hiredly_x")}
                      </LinkText>
                    </VanillaLinkStyled>
                    <VanillaLinkStyled href="/updates">
                      <LinkText id={"footer-updates-button"}>
                        {t("footer.updates")}
                      </LinkText>
                    </VanillaLinkStyled>
                    <VanillaLinkStyled href="/directory">
                      <LinkText id={"footer-directory-button"}>
                        {t("footer.directory")}
                      </LinkText>
                    </VanillaLinkStyled>
                  </GridLinks>
                </ColumnLink>
                <ColumnLink>
                  <CompanyTitleStyled>
                    {t("footer.jobseeker_title")}
                  </CompanyTitleStyled>
                  <GridLinks>
                    <VanillaLinkStyled href="/sitemap/jobs-by-specialisation">
                      <LinkText id={"footer-jobs-by-specialisation-button"}>
                        {t("footer.jobs_by_specialisation")}
                      </LinkText>
                    </VanillaLinkStyled>
                    <VanillaLinkStyled href="/sitemap/jobs-by-location">
                      <LinkText id={"footer-jobs-by-state-button"}>
                        {t("footer.jobs_by_location")}
                      </LinkText>
                    </VanillaLinkStyled>
                    <VanillaLinkStyled href="/sitemap/jobs-by-type">
                      <LinkText id={"footer-jobs-by-type-button"}>
                        {t("footer.jobs_by_type")}
                      </LinkText>
                    </VanillaLinkStyled>
                    <VanillaLinkStyled href="/sitemap/jobs-by-experience-level">
                      <LinkText id={"footer-jobs-by-experience-level-button"}>
                        {t("footer.jobs_by_experience_level")}
                      </LinkText>
                    </VanillaLinkStyled>
                    <VanillaLinkStyled href="/companies">
                      <LinkText id={"footer-companies-button"}>
                        {t("footer.companies")}
                      </LinkText>
                    </VanillaLinkStyled>
                    <VanillaLinkStyled href="/advice">
                      <LinkText id={"footer-advice-button"}>
                        {t("footer.advice")}
                      </LinkText>
                    </VanillaLinkStyled>
                    <VanillaLinkStyled href="/scholarships">
                      <LinkText id={"footer-scholarships-button"}>
                        Scholarship Hub
                      </LinkText>
                    </VanillaLinkStyled>
                    <VanillaLinkStyled href="/retrenchment">
                      <LinkText id={"footer-retrenchment-button"}>
                        Retrenchment Support Guide
                      </LinkText>
                    </VanillaLinkStyled>
                  </GridLinks>
                </ColumnLink>
                <ColumnLink>
                  <CompanyTitleStyled>
                    {t("footer.employer_title")}
                  </CompanyTitleStyled>
                  <GridLinks>
                    <LinkExternal
                      href={
                        process.env.NEXT_PUBLIC_JSW_GEOLOCATION === "sg"
                          ? "http://hub.hiredly.com/hiredly-sg-employer-waitlist"
                          : setEmployerParams()
                      }
                    >
                      <LinkText id={"footer-start-hiring-button"}>
                        {t("footer.start_hiring")}
                      </LinkText>
                    </LinkExternal>
                    <LinkExternal href="/hiredly-x">
                      <LinkText id={"footer-headhunting-button"}>
                        {t("footer.headhunting_service")}
                      </LinkText>
                    </LinkExternal>
                  </GridLinks>
                  <GetInTouchTitleStyled>
                    {t("footer.get_in_touch")}
                  </GetInTouchTitleStyled>
                  <GridLinks>
                    <LinkContactExternal href="tel:+60327710141">
                      <PhoneIconStyled />
                      <LinkText>+603-2771 0141 ({t("footer.office")})</LinkText>
                    </LinkContactExternal>
                    <LinkContactExternal
                      href="https://wa.me/601155899368"
                      target="_blank"
                      rel="noopener"
                    >
                      <WhatsappIconStyled icon={faWhatsapp} />
                      <LinkText>
                        +6011-5589 9368 ({t("footer.whatsapp")})
                      </LinkText>
                    </LinkContactExternal>
                    <LinkContactExternal href="tel:+60162999495">
                      <PhoneIconStyled />
                      <LinkText>+6016-299 9495 ({t("footer.sales")})</LinkText>
                    </LinkContactExternal>
                    <LinkContactExternal href="tel:+601154460461">
                      <PhoneIconStyled />
                      <LinkText>
                        +6011-5446 0461 ({t("footer.customer_service")})
                      </LinkText>
                    </LinkContactExternal>
                  </GridLinks>
                </ColumnLink>
              </ColumnContainerMiddle>
            </FirstContentContainer>

            <ColumnContainer section="download_app_logo">
              <LinkStyled
                href="https://itunes.apple.com/us/app/wobb/id981491669?mt=8"
                rel="noopener"
                target="_blank"
              >
                <DownloadAppLogo
                  src={
                    config.assetDomain +
                    "/images/hiredly/app_store_download_button.svg"
                  }
                  alt="app_store_download_button"
                />
              </LinkStyled>
              <LinkStyled
                href="https://play.google.com/store/apps/details?id=com.wobb.hunted&hl=en"
                rel="noopener"
                target="_blank"
              >
                <DownloadAppLogo
                  src={
                    config.assetDomain +
                    "/images/hiredly/google_play_download_button.svg"
                  }
                  alt="google_play_download_button"
                />
              </LinkStyled>
              <LinkStyled
                href="https://appgallery.huawei.com/#/app/C101027941?channelId=homepage-footer&id=8c375cc9194d469488f3f163394cfbd5&s=EDFF426DF95D1FCBCCE03918FB64DFF9C7197D34B481DE8A2BE8654FDF391EFB&detailType=0&v="
                rel="noopener"
                target="_blank"
              >
                <DownloadAppLogo
                  src={
                    config.assetDomain +
                    "/images/hiredly/app_gallery_download_button.svg"
                  }
                  alt="app_gallery_download_button"
                />
              </LinkStyled>
              <QrCode
                src={
                  config.assetDomain +
                  "/images/landing/onelink-app-download-qr.png"
                }
                alt="app_gallery_download_button"
              />
            </ColumnContainer>
          </ContentContainer>

          <CopyrightContainer>
            <GridIconsContainer>
              <GridIcons>
                <LinkIcon
                  id={"footer-facebook-button"}
                  href="https://www.facebook.com/hiredly"
                  rel="noopener"
                  target="_blank"
                >
                  <IconStyled icon={faFacebook} />
                </LinkIcon>
                <LinkIcon
                  id={"footer-instagram-button"}
                  href="https://www.instagram.com/hiredlyofficial/"
                  rel="noopener"
                  target="_blank"
                >
                  <IconStyled icon={faInstagram} />
                </LinkIcon>
                <LinkIcon
                  id={"footer-tiktok-button"}
                  href="https://www.tiktok.com/@hiredly.official"
                  rel="noopener"
                  target="_blank"
                >
                  <IconStyled icon={faTiktok} />
                </LinkIcon>
                <LinkIcon
                  id={"footer-linkedin-button"}
                  href="https://www.linkedin.com/companies/hiredlymy/"
                  rel="noopener"
                  target="_blank"
                >
                  <IconStyled icon={faLinkedinIn} />
                </LinkIcon>
                <LinkIcon
                  id={"footer-spotify-button"}
                  href="https://open.spotify.com/user/hjpf36a3ey64jq35xxx2d2rzd?si=441f177d08d74926"
                  rel="noopener"
                  target="_blank"
                >
                  <IconStyled icon={faSpotify} />
                </LinkIcon>
                <LinkIcon
                  id={"footer-youtube-button"}
                  href="https://www.youtube.com/hiredly"
                  rel="noopener"
                  target="_blank"
                >
                  <IconStyled icon={faYoutube} />
                </LinkIcon>
              </GridIcons>
            </GridIconsContainer>

            <CopyrightText>
              {`v${packageJson.version} `}
              {t("footer.copyright", { year })}
            </CopyrightText>

            <CopyrightContainerMiddle>
              <NextLink href="/community-guidelines">
                <LinkTextNoMargin id={"footer-community-guidelines-button"}>
                  {t("footer.community_guidelines")}
                </LinkTextNoMargin>
              </NextLink>
              <VerticalSeparator></VerticalSeparator>
              <NextLink href="/privacy-policy">
                <LinkTextNoMargin id={"footer-privacy-policy-button"}>
                  {t("footer.privacy_policy")}
                </LinkTextNoMargin>
              </NextLink>
              <VerticalSeparator></VerticalSeparator>
              <NextLink href="/terms-and-conditions">
                <LinkTextNoMargin id={"footer-terms-and-conditions-button"}>
                  {t("footer.terms_and_conditions")}
                </LinkTextNoMargin>
              </NextLink>
              <VerticalSeparator></VerticalSeparator>
              <NextLink href="/sitemap">
                <LinkTextNoMargin id={"footer-sitemap-button"}>
                  {t("footer.site_map")}
                </LinkTextNoMargin>
              </NextLink>
            </CopyrightContainerMiddle>
          </CopyrightContainer>
        </ContainerStyled>
      ) : null}
    </Fragment>
  );
}
